import React from 'react'
import { Typography } from '@material-ui/core'

import { SectionBlock } from '../SectionBlock'

import { useStyles } from './MonitorSection.style'

const MonitorSection = (sectionProps) => {
  const classes = useStyles()

  return (
    <SectionBlock
      containerClassName={classes.container}
      nextSectionId='eventTimingSection'
      {...sectionProps}>
      <div className={classes.mainContainer}>
        <div className={classes.content}>
          <Typography className={classes.title}>
            MONITOREÁ Y
            <br />
            <span>ADMINISTRÁ</span>
            <br />
            LOS <span>INSCRIPTOS</span>
            <br />A TU EVENTO.
          </Typography>
        </div>
        <div className={classes.sportImage} />
      </div>
    </SectionBlock>
  )
}

export default MonitorSection
